export default "__VITE_ASSET__BN1BRQc3__"